import enBackToTop from '@components/back-to-top/locales/en.json'
import esBackToTop from '@components/back-to-top/locales/es.json'
import ptBackToTop from '@components/back-to-top/locales/pt.json'
import enCampaignCardLink from '@components/campaign-card-link/locales/en.json'
import esCampaignCardLink from '@components/campaign-card-link/locales/es.json'
import ptCampaignCardLink from '@components/campaign-card-link/locales/pt.json'
import enCampaignFooterStatus from '@components/campaign-footer-status/locales/en.json'
import esCampaignFooterStatus from '@components/campaign-footer-status/locales/es.json'
import ptCampaignFooterStatus from '@components/campaign-footer-status/locales/pt.json'
import enCampaignHead from '@components/campaign-head/locales/en.json'
import esCampaignHead from '@components/campaign-head/locales/es.json'
import ptCampaignHead from '@components/campaign-head/locales/pt.json'
import enCampaignModalFilter from '@components/campaign-modal-filter/locales/en.json'
import esCampaignModalFilter from '@components/campaign-modal-filter/locales/es.json'
import ptCampaignModalFilter from '@components/campaign-modal-filter/locales/pt.json'
import enCampaignStatusBar from '@components/campaign-status-bar/locales/en.json'
import esCampaignStatusBar from '@components/campaign-status-bar/locales/es.json'
import ptCampaignStatusBar from '@components/campaign-status-bar/locales/pt.json'
import enCanReceive from '@components/can-receive/locales/en.json'
import esCanReceive from '@components/can-receive/locales/es.json'
import ptCanReceive from '@components/can-receive/locales/pt.json'
import enContentByProfile from '@components/content-by-profile/locales/en.json'
import esContentByProfile from '@components/content-by-profile/locales/es.json'
import ptContentByProfile from '@components/content-by-profile/locales/pt.json'
import enExtraRequirements from '@components/extra-requirements/locales/en.json'
import esExtraRequirements from '@components/extra-requirements/locales/es.json'
import ptExtraRequirements from '@components/extra-requirements/locales/pt.json'
import enMediaApproval from '@components/media-approval-card/locales/en.json'
import esMediaApproval from '@components/media-approval-card/locales/es.json'
import ptMediaApproval from '@components/media-approval-card/locales/pt.json'
import enMediaPreApproval from '@components/media-pre-approval-card/locales/en.json'
import esMediaPreApproval from '@components/media-pre-approval-card/locales/es.json'
import ptMediaPreApproval from '@components/media-pre-approval-card/locales/pt.json'
import enFilterComponent from '@components/modal-filter/locales/en.json'
import esFilterComponent from '@components/modal-filter/locales/es.json'
import ptFilterComponent from '@components/modal-filter/locales/pt.json'
import enOverlayApproveContent from '@components/overlay-approve-content/locales/en.json'
import esOverlayApproveContent from '@components/overlay-approve-content/locales/es.json'
import ptOverlayApproveContent from '@components/overlay-approve-content/locales/pt.json'
import enOverlayContentLink from '@components/overlay-content-link/locales/en.json'
import esOverlayContentLink from '@components/overlay-content-link/locales/es.json'
import ptOverlayContentLink from '@components/overlay-content-link/locales/pt.json'
import enOverlayContentVideo from '@components/overlay-content-video/locales/en.json'
import esOverlayContentVideo from '@components/overlay-content-video/locales/es.json'
import ptOverlayContentVideo from '@components/overlay-content-video/locales/pt.json'
import enPerfilRequirements from '@components/perfil-requirements/locales/en.json'
import esPerfilRequirements from '@components/perfil-requirements/locales/es.json'
import ptPerfilRequirements from '@components/perfil-requirements/locales/pt.json'
import enResearchPreRecruitment from '@components/research-pre-recruitment/locales/en.json'
import esResearchPreRecruitment from '@components/research-pre-recruitment/locales/es.json'
import ptResearchPreRecruitment from '@components/research-pre-recruitment/locales/pt.json'
import enSelectSocialNetwork from '@components/select-social-network/locales/en.json'
import esSelectSocialNetwork from '@components/select-social-network/locales/es.json'
import ptSelectSocialNetwork from '@components/select-social-network/locales/pt.json'
import enSocialNetworkFilter from '@components/social-network-filter/locales/en.json'
import esSocialNetworkFilter from '@components/social-network-filter/locales/es.json'
import ptSocialNetworkFilter from '@components/social-network-filter/locales/pt.json'
import enTokenRenewalBox from '@components/token-renewal-box/locales/en.json'
import esTokenRenewalBox from '@components/token-renewal-box/locales/es.json'
import ptTokenRenewalBox from '@components/token-renewal-box/locales/pt.json'
import enTtcmWarning from '@components/ttcm-warning/locales/en.json'
import esTtcmWarning from '@components/ttcm-warning/locales/es.json'
import ptTtcmWarning from '@components/ttcm-warning/locales/pt.json'
import enCampaignDetails from '@pages/details/locales/en.json'
import esCampaignDetails from '@pages/details/locales/es.json'
import ptCampaignDetails from '@pages/details/locales/pt.json'
import enApprovePage from '@pages/details/pages/approve/locales/en.json'
import esApprovePage from '@pages/details/pages/approve/locales/es.json'
import ptApprovePage from '@pages/details/pages/approve/locales/pt.json'
import enDetailing from '@pages/details/pages/detailing/locales/en.json'
import esDetailing from '@pages/details/pages/detailing/locales/es.json'
import ptDetailing from '@pages/details/pages/detailing/locales/pt.json'
import enEngage from '@pages/details/pages/engage/locales/en.json'
import esEngage from '@pages/details/pages/engage/locales/es.json'
import ptEngage from '@pages/details/pages/engage/locales/pt.json'
import enMaterialNoticesPage from '@pages/details/pages/material-notices/locales/en.json'
import esMaterialNoticesPage from '@pages/details/pages/material-notices/locales/es.json'
import ptMaterialNoticesPage from '@pages/details/pages/material-notices/locales/pt.json'
import enOrientationContent from '@pages/details/pages/orientation-content/locales/en.json'
import esOrientationContent from '@pages/details/pages/orientation-content/locales/es.json'
import ptOrientationContent from '@pages/details/pages/orientation-content/locales/pt.json'
import enCardToUploadContent from '@pages/details/pages/publish/components/card-to-upload-content/locales/en.json'
import esCardToUploadContent from '@pages/details/pages/publish/components/card-to-upload-content/locales/es.json'
import ptCardToUploadContent from '@pages/details/pages/publish/components/card-to-upload-content/locales/pt.json'
import enCardToUploadVideo from '@pages/details/pages/publish/components/card-to-upload-video/locales/en.json'
import esCardToUploadVideo from '@pages/details/pages/publish/components/card-to-upload-video/locales/es.json'
import ptCardToUploadVideo from '@pages/details/pages/publish/components/card-to-upload-video/locales/pt.json'
import enPublishPage from '@pages/details/pages/publish/locales/en.json'
import esPublishPage from '@pages/details/pages/publish/locales/es.json'
import ptPublishPage from '@pages/details/pages/publish/locales/pt.json'
import enReportPage from '@pages/details/pages/report/locales/en.json'
import esReportPage from '@pages/details/pages/report/locales/es.json'
import ptReportPage from '@pages/details/pages/report/locales/pt.json'
import enCampaignListHeader from '@pages/home-campaign/components/campaign-list-header/locales/en.json'
import esCampaignListHeader from '@pages/home-campaign/components/campaign-list-header/locales/es.json'
import ptCampaignListHeader from '@pages/home-campaign/components/campaign-list-header/locales/pt.json'
import enHomeCampaign from '@pages/home-campaign/locales/en.json'
import esHomeCampaign from '@pages/home-campaign/locales/es.json'
import ptHomeCampaign from '@pages/home-campaign/locales/pt.json'
import enCampaignFooter from '@pages/summary/components/campaign-footer/locales/en.json'
import esCampaignFooter from '@pages/summary/components/campaign-footer/locales/es.json'
import ptCampaignFooter from '@pages/summary/components/campaign-footer/locales/pt.json'
import enModalAcceptCampaign from '@pages/summary/components/modal-accept-campaign/locales/en.json'
import esModalAcceptCampaign from '@pages/summary/components/modal-accept-campaign/locales/es.json'
import ptModalAcceptCampaign from '@pages/summary/components/modal-accept-campaign/locales/pt.json'
import enModalContractAccepted from '@pages/summary/components/modal-contract-accepted/locales/en.json'
import esModalContractAccepted from '@pages/summary/components/modal-contract-accepted/locales/es.json'
import ptModalContractAccepted from '@pages/summary/components/modal-contract-accepted/locales/pt.json'
import enModalRemoveInterest from '@pages/summary/components/modal-remove-interest/locales/en.json'
import esModalRemoveInterest from '@pages/summary/components/modal-remove-interest/locales/es.json'
import ptModalRemoveInterest from '@pages/summary/components/modal-remove-interest/locales/pt.json'
import enPreRecruitment from '@pages/summary/components/pre-recruitment/locales/en.json'
import esPreRecruitment from '@pages/summary/components/pre-recruitment/locales/es.json'
import ptPreRecruitment from '@pages/summary/components/pre-recruitment/locales/pt.json'
import enRegisterRequirements from '@pages/summary/components/register-requirements/locales/en.json'
import esRegisterRequirements from '@pages/summary/components/register-requirements/locales/es.json'
import ptRegisterRequirements from '@pages/summary/components/register-requirements/locales/pt.json'
import enHeaderTextCampaignFormat from '@src/pages/details/pages/report/components/header-text-campaign-format/locales/en.json'
import esHeaderTextCampaignFormat from '@src/pages/details/pages/report/components/header-text-campaign-format/locales/es.json'
import ptHeaderTextCampaignFormat from '@src/pages/details/pages/report/components/header-text-campaign-format/locales/pt.json'
import i18n from 'i18next'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'
import enGlobal from './assets/locales/en.json'
import esGlobal from './assets/locales/es.json'
import ptGlobal from './assets/locales/pt.json'
import enBrandRequirements from './components/brand-requirements/locales/en.json'
import esBrandRequirements from './components/brand-requirements/locales/es.json'
import ptBrandRequirements from './components/brand-requirements/locales/pt.json'
import enModalIncompleteProfile from './components/modal-incomplete-profile/locales/en.json'
import esModalIncompleteProfile from './components/modal-incomplete-profile/locales/es.json'
import ptModalIncompleteProfile from './components/modal-incomplete-profile/locales/pt.json'

export const defaultNS = 'globalCampaigns'
export const resources = {
  en: {
    globalCampaigns: enGlobal,
    campaignDetails: enCampaignDetails,
    campaignHead: enCampaignHead,
    campaignCardLink: enCampaignCardLink,
    campaignListHeader: enCampaignListHeader,
    socialNetworkFilter: enSocialNetworkFilter,
    homeCampaign: enHomeCampaign,
    backToTop: enBackToTop,
    mediaPreApproval: enMediaPreApproval,
    campaignModalFilter: enCampaignModalFilter,
    filterComponent: enFilterComponent,
    campaignContentOrientation: enOrientationContent,
    approvePage: enApprovePage,
    mediaApproval: enMediaApproval,
    campaignDetailing: enDetailing,
    overlayApproveContent: enOverlayApproveContent,
    overlayContentLink: enOverlayContentLink,
    preRecruitment: enPreRecruitment,
    registerRequirements: enRegisterRequirements,
    campaignStatusBar: enCampaignStatusBar,
    selectSocialNetwork: enSelectSocialNetwork,
    cardToUploadContent: enCardToUploadContent,
    publishPage: enPublishPage,
    perfilRequirements: enPerfilRequirements,
    canReceive: enCanReceive,
    extraRequirements: enExtraRequirements,
    researchPreRecruitment: enResearchPreRecruitment,
    campaignMaterialNoticesPage: enMaterialNoticesPage,
    campaignFooter: enCampaignFooter,
    campaignFooterStatus: enCampaignFooterStatus,
    engage: enEngage,
    ttcmWarning: enTtcmWarning,
    headerTextCampaignFormat: enHeaderTextCampaignFormat,
    reportPage: enReportPage,
    modalAcceptCampaign: enModalAcceptCampaign,
    modalRemoveInterest: enModalRemoveInterest,
    modalContractAccepted: enModalContractAccepted,
    cardToUploadVideo: enCardToUploadVideo,
    overlayContentVideo: enOverlayContentVideo,
    tokenRenewalBox: enTokenRenewalBox,
    contentByProfile: enContentByProfile,
    brandRequirements: enBrandRequirements,
    modalIncompleteProfile: enModalIncompleteProfile,
  },
  pt: {
    globalCampaigns: ptGlobal,
    campaignDetails: ptCampaignDetails,
    campaignHead: ptCampaignHead,
    campaignCardLink: ptCampaignCardLink,
    campaignListHeader: ptCampaignListHeader,
    socialNetworkFilter: ptSocialNetworkFilter,
    homeCampaign: ptHomeCampaign,
    backToTop: ptBackToTop,
    mediaPreApproval: ptMediaPreApproval,
    campaignModalFilter: ptCampaignModalFilter,
    filterComponent: ptFilterComponent,
    campaignContentOrientation: ptOrientationContent,
    approvePage: ptApprovePage,
    mediaApproval: ptMediaApproval,
    campaignDetailing: ptDetailing,
    overlayApproveContent: ptOverlayApproveContent,
    overlayContentLink: ptOverlayContentLink,
    preRecruitment: ptPreRecruitment,
    registerRequirements: ptRegisterRequirements,
    campaignStatusBar: ptCampaignStatusBar,
    selectSocialNetwork: ptSelectSocialNetwork,
    cardToUploadContent: ptCardToUploadContent,
    publishPage: ptPublishPage,
    perfilRequirements: ptPerfilRequirements,
    canReceive: ptCanReceive,
    extraRequirements: ptExtraRequirements,
    researchPreRecruitment: ptResearchPreRecruitment,
    campaignMaterialNoticesPage: ptMaterialNoticesPage,
    campaignFooter: ptCampaignFooter,
    campaignFooterStatus: ptCampaignFooterStatus,
    engage: ptEngage,
    ttcmWarning: ptTtcmWarning,
    headerTextCampaignFormat: ptHeaderTextCampaignFormat,
    reportPage: ptReportPage,
    modalAcceptCampaign: ptModalAcceptCampaign,
    modalRemoveInterest: ptModalRemoveInterest,
    modalContractAccepted: ptModalContractAccepted,
    cardToUploadVideo: ptCardToUploadVideo,
    overlayContentVideo: ptOverlayContentVideo,
    tokenRenewalBox: ptTokenRenewalBox,
    contentByProfile: ptContentByProfile,
    brandRequirements: ptBrandRequirements,
    modalIncompleteProfile: ptModalIncompleteProfile,
  },
  es: {
    globalCampaigns: esGlobal,
    campaignDetails: esCampaignDetails,
    campaignHead: esCampaignHead,
    campaignCardLink: esCampaignCardLink,
    campaignListHeader: esCampaignListHeader,
    socialNetworkFilter: esSocialNetworkFilter,
    homeCampaign: esHomeCampaign,
    backToTop: esBackToTop,
    mediaPreApproval: esMediaPreApproval,
    campaignModalFilter: esCampaignModalFilter,
    filterComponent: esFilterComponent,
    campaignContentOrientation: esOrientationContent,
    approvePage: esApprovePage,
    mediaApproval: esMediaApproval,
    campaignDetailing: esDetailing,
    overlayApproveContent: esOverlayApproveContent,
    overlayContentLink: esOverlayContentLink,
    preRecruitment: esPreRecruitment,
    registerRequirements: esRegisterRequirements,
    campaignStatusBar: esCampaignStatusBar,
    selectSocialNetwork: esSelectSocialNetwork,
    cardToUploadContent: esCardToUploadContent,
    publishPage: esPublishPage,
    perfilRequirements: esPerfilRequirements,
    canReceive: esCanReceive,
    extraRequirements: esExtraRequirements,
    researchPreRecruitment: esResearchPreRecruitment,
    campaignMaterialNoticesPage: esMaterialNoticesPage,
    campaignFooter: esCampaignFooter,
    campaignFooterStatus: esCampaignFooterStatus,
    engage: esEngage,
    ttcmWarning: esTtcmWarning,
    headerTextCampaignFormat: esHeaderTextCampaignFormat,
    reportPage: esReportPage,
    modalAcceptCampaign: esModalAcceptCampaign,
    modalRemoveInterest: esModalRemoveInterest,
    modalContractAccepted: esModalContractAccepted,
    cardToUploadVideo: esCardToUploadVideo,
    overlayContentVideo: esOverlayContentVideo,
    tokenRenewalBox: esTokenRenewalBox,
    contentByProfile: esContentByProfile,
    brandRequirements: esBrandRequirements,
    modalIncompleteProfile: esModalIncompleteProfile,
  },
} as const

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    defaultNS,
    ns: [
      'globalCampaigns',
      'campaignDetails',
      'campaignHead',
      'campaignListHeader',
      'socialNetworkFilter',
      'homeCampaign',
      'campaignCardLink',
      'backToTop',
      'mediaPreApproval',
      'mediaApproval',
      'campaignModalFilter',
      'filterComponent',
      'campaignContentOrientation',
      'campaignDetailing',
      'overlayApproveContent',
      'overlayContentLink',
      'approvePage',
      'preRecruitment',
      'registerRequirements',
      'campaignStatusBar',
      'selectSocialNetwork',
      'cardToUploadContent',
      'publishPage',
      'canReceive',
      'extraRequirements',
      'researchPreRecruitment',
      'campaignMaterialNoticesPage',
      'campaignFooter',
      'campaignFooterStatus',
      'engage',
      'ttcmWarning',
      'headerTextCampaignFormat',
      'reportPage',
      'modalAcceptCampaign',
      'modalRemoveInterest',
      'modalContractAccepted',
      'cardToUploadVideo',
      'overlayContentVideo',
      'tokenRenewalBox',
      'contentByProfile',
      'brandRequirements',
      'modalIncompleteProfile',
    ],
    load: 'all',
    supportedLngs: ['en', 'es', 'pt'],
    lng: navigator.language?.split('-')[0] || 'en',
    fallbackLng: 'en',
    debug: false,
    cache: {
      enabled: false,
    },
    resources,
  })

export default i18n
